import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export function GovernanceForbiddenPage({ fallbackPath }: { fallbackPath: string }) {
  const navigate = useNavigate();

  return <Result
    status="403"
    title="没有访问权限"
    subTitle="当前管理员账号没有访问此页面所需的业务权限。如需使用，请联系超级管理员按岗位授权。"
    extra={<Button type="primary" onClick={() => navigate(fallbackPath, { replace: true })}>返回可访问页面</Button>}
  />;
}

